const TimeToEnd = (start, end) => {
  var endDate = new Date(end);
  var startDate = new Date(start);

  var difference = endDate - startDate;
  var days = Math.floor(difference / (1000 * 60 * 60 * 24));
  return days;
};
export default TimeToEnd;
